const React = require("react");

module.exports = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 60 60" fill="none">
    <circle cx="29.5" cy="29.5" r="22.5" fill="#FFF"/>
    <path fill="#3e4044" d="M22 22h15v14H22z"/>
  </svg>
)
